module.exports = __webpack_public_path__ + "static/media/axis-orientation.dd4dd384.png";